import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthProvider";
import AppShell from "../../../common/shell/AppShell";
import { appRoutes, sidebarTabs, findRouteByPathname } from "../../../common/routes/routesConfig";
import { useIsAdmin } from "../../hooks/useIsAdmin";

export default function MainPage() {
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();
  const { user } = useAuth();

  const tabs = useMemo(() => sidebarTabs(isAdmin), [isAdmin]);

  return (
    <AppShell
      basePath="/home"
      tabs={tabs}
      routes={appRoutes}
      isAdmin={isAdmin}
      titleResolver={(p) => findRouteByPathname(p)?.label ?? "Dashboard"}
      getActivePath={(p) => p.replace(/^\/home\/?/, "").split("/")[0] || ""}
      onTabNavigate={(tab, navigateDefault) => {
        if (!isAdmin && tab.key === "balance") {
          return navigate(`/home/agent/${user?.uuid ?? ""}`);
        }
        navigateDefault(tab);
      }}
    />
  );
}
